import { Component, OnInit } from '@angular/core'
import { AuthenticationService } from '../../_services/authentication.service'
import { RequestsService } from '../../_shared/services/requests.service'
import { HelperFunctions } from '../../_shared/utils/helper-functions'
import { FormGroup, Validators, FormBuilder, FormArray } from '@angular/forms'
import * as moment from 'moment'

declare var jQuery: any

@Component({
  selector: 'app-diagnosis-inquiry',
  templateUrl: './diagnosis-inquiry.component.html',
  styleUrls: ['./diagnosis-inquiry.component.scss'],
})
export class DiagnosisInquiryComponent implements OnInit {
  constructor(
    private authenticationService: AuthenticationService,
    private requestService: RequestsService,
    private helperFunction: HelperFunctions,
    private fb: FormBuilder
  ) { }

  isLoadingInquiries: boolean
  inquiriesData: any
  replyInquiryForm: FormGroup
  countryName: string
  inputsToSelect: any
  singleInquiryData: any
  inqPage = 1
  count = 10
  loading = false
  inputs: any
  selectedInputs: Array<any> = []
  selectedInputName: string
  newInputsArray: any
  isLoadingInputs: boolean
  moment: any = moment
  selectedImage: string
  showImage = false
  searchItem: string
  filterDiagnosisInfo: any

  ngOnInit(): void {
    const currentUser = this.authenticationService.getCurrentUserValue()
    const { country } = currentUser
    this.countryName = country

    this.replyInquiryForm = this.fb.group({
      media: this.fb.array([]),
      recommend_input: [],
      general_recommendation: '',
      input_quantites: '',
    })
    this.loadDiagnosisInquiry()
    this.getInputs()
  }

  loadDiagnosisInquiry(): void {
    this.isLoadingInquiries = true
    this.requestService
      .dash_get(`inquiry/get-inquiries`, null, true)
      .subscribe((res) => {
        this.inquiriesData = res.data
        this.filterDiagnosisInfo = res.data
        this.isLoadingInquiries = false
      })
  }

  getInputs(): void {
    this.requestService
      .dash_get(`mobile/input/${this.countryName}`, null)
      .subscribe((res) => {
        let inputs = []
        res.data.map((each) => {
          let input = {
            name: each.name,
            id: each.id,
          }
          inputs.push(input)
        })
        this.inputs = inputs
        this.getSelectItems()
      })
  }

  getSelectItems() {
    let inputItems = []

    this.inputs
      ? this.inputs.map((each) => {
        inputItems.push({ label: each.name, value: each.id })
        this.inputsToSelect = inputItems
      })
      : null
  }

  setSingleInquiriesViewData(data: object) {
    this.singleInquiryData = data
    this.replyInquiryForm.patchValue({
      general_recommendation: this.singleInquiryData.general_recommendation,
      input_quantites: this.singleInquiryData.input_quantites,
    })
    this.replyInquiryForm
      .get('recommend_input')
      .setValue(this.singleInquiryData.recommend_input)
    this.replyInquiryForm.setControl(
      'media',
      this.setExistingMedia(this.singleInquiryData.media)
    )
  }

  setExistingMedia(existingMedia): FormArray {
    const formArray = new FormArray([])
    existingMedia
      ? existingMedia.forEach((element) => {
        formArray.push(
          this.fb.group({
            photo_url: element.photo_url,
            annotation: element.annotation.toString(),
          })
        )
      })
      : null
    return formArray
  }

  editDiagnosisReply(): FormArray {
    return this.replyInquiryForm.get('media') as FormArray
  }

  refreshPage(): void {
    this.loadDiagnosisInquiry()
    this.getInputs()
  }

  replyToDiagnosisInquiry(id) {
    this.loading = true
    let agronomyMedia = []
    let formData = new FormData()
    this.replyInquiryForm.value.media.forEach((element, index) => {
      let mediaObject = {
        photo_url: element.photo_url,
        annotation: element.annotation.split(','),
      }

      agronomyMedia.push(mediaObject)
    })

    // let inputsQuantites = this.replyInquiryForm.value.input_quantites.split(",")

    if (this.checkQauntitesMatchInputs()) {
      formData.append('media', JSON.stringify(agronomyMedia))
      formData.append(
        'general_recommendation',
        this.replyInquiryForm.value.general_recommendation
      )
      formData.append(
        'recommend_input',
        this.replyInquiryForm.value.recommend_input
      )
      formData.append(
        'input_quantites',
        this.replyInquiryForm.value.input_quantites
          ? this.replyInquiryForm.value.input_quantites
          : []
      )

      this.requestService
        .dash_post(`inquiry/single/${id}`, formData, true)
        .subscribe((res) => {
          // console.log(res.success);
          this.loading = false
          if (res.success === true) {
            this.refreshPage()
            this.resetEditModal()
            this.helperFunction.displayAlert(res.message, 'success')
          } else {
            this.loading = false
            this.helperFunction.displayAlert(res.message, 'error')
          }
        }, err => {
          this.loading = false
        })
    } else {
      this.loading = false
      this.helperFunction.displayAlert(
        'Please ensure that you have provided corresponding quantities for all inputs selected',
        'error'
      )
    }
  }

  resetEditModal() {
    jQuery('#replyInquiry').modal('hide')
    this.replyInquiryForm.reset()
  }

  enlargeImage(evt) {
    this.showImage = true
    this.selectedImage = evt.target.src
  }

  closeImageDisplay() {
    this.showImage = false
  }

  filterDiagnosisInquiry(event) {
    this.searchItem = event.target.value
    this.filterDiagnosisInfo = this.inquiriesData.filter(
      (input) =>
        input.username.toLowerCase().indexOf(this.searchItem.toLowerCase()) !==
        -1 ||
        input.user_type.toLowerCase().indexOf(this.searchItem.toLowerCase()) !==
        -1
    )
  }
  checkQauntitesMatchInputs() {
    let input_rec = this.replyInquiryForm.value.recommend_input
    let quantity_rec = this.replyInquiryForm.value.input_quantites
    if (quantity_rec) {
      quantity_rec = quantity_rec.split(",")
    }
    if (quantity_rec.length === input_rec.length) {
      return true
    } else {
      return false
    }
  }
}
